import { fromJS, Map as iMap } from 'immutable';

import * as constants from './walkthru-constants';

const initialState = iMap({
  isTourReady: false,
  eventName: null,
  steps: [],
});

export function walkthru(state = initialState, { type, payload }) {
  switch (type) {
    case constants.SET_STEPS:
      return state.merge(fromJS({
        steps: payload.steps,
        eventName: payload.eventName,
        isTourReady: true,
      }));
    case constants.RESET:
      return state.merge(fromJS({
        steps: [],
        eventName: null,
        isTourReady: false,
        isOpen: false,
      }));
    default:
      return initialState.merge(state);
  }
}



// WEBPACK FOOTER //
// ./src/app/stores/ui/components/walkthru/walkthru-reducer.js